import { render, staticRenderFns } from "./itemCaracEdit.vue?vue&type=template&id=de54c0c0"
import script from "./itemCaracEdit.vue?vue&type=script&lang=js"
export * from "./itemCaracEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports